import React from 'react'


import {
    Card,
     } from "react-bootstrap" 

function AboutMe(){
    return (
        
        <Card className="AboutMe" body>About Me.</Card>
        
    )
}

export default AboutMe;